import React, { useContext } from 'react';
import './GoogleLoginButton.css';
import url from '../url.js';
import { AuthContext } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { getPostLoginRedirect } from '../utils/studentClassRoutes';

const GoogleLoginButton = () => {
  const { checkAuth } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    window.location.href = `${url.backendHost}auth/google`;
    
    // Check auth status after a short delay to allow for cookie setting
    const checkAuthStatus = async () => {
      try {
        const user = await checkAuth();
        if (user) {
          localStorage.setItem('userId', user.id);
          localStorage.setItem('userName', user.name);
          localStorage.setItem('userEmail', user.email);
        }
        navigate(getPostLoginRedirect() || '/main');
      } catch (error) {
        console.error('Google login failed:', error);
      }
    };
    
    // Check auth status after redirect
    window.addEventListener('load', checkAuthStatus);
  };

  return (
    <button onClick={handleGoogleLogin} className="google-login-button">
      <img
        src="https://www.google.com/favicon.ico"
        alt="Google"
        className="google-icon"
      />
      Sign in with Google
    </button>
  );
};

export default GoogleLoginButton; 